<script lang="ts">
  import { onMount } from 'svelte';
  import Select from 'svelte-select/Select.svelte';
  import { debugLog } from '../../lib/debug-log';
  export let selectedIds: any;
  export let selectedParts: IItem[];

  interface IItem {
    category: string;
    label: string;
    value: string;
    key: string;
    id: number;
  }

  let URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbdcb`;

  let collection: IItem[];

  onMount(async () => {
    try {
      const result = await fetch(`${URL}/parts`, {
        headers: {
          Accept: 'application/json, text/plain',
          'Content-Type': 'application/json;charset=UTF-8',
          'X-Custom-Header': 'mb-cashback-2025-header',
        },
      });
      const partsData = await result.json();
      collection = partsData.map((p: IItem) => {
        return {
          ...p,
          label: p.key,
          value: p.key,
        };
      });
      selectedIds = JSON.parse((selectedIds as string) || '[]');
      selectedParts = collection?.filter(
        (c) => c.id == selectedIds?.find((s: any) => s == c.id),
      );
    } catch (error) {
      debugLog({ error });
      collection = [
        // Default values
      ];
    }
  });
</script>

<div class="w-[320px] md:w-[34rem]">
  <Select
    multiple={true}
    items={collection}
    bind:value={selectedParts}
    on:change={(e) => debugLog(e)}
  />
</div>
